import { UIStore } from './ui-store';

export class SetBoxCalculationArticleAction {
  public setBoxCalculationArticle(this: UIStore, boxCalculationArticleId?: string): void {
    this.boxCalculationArticleId = boxCalculationArticleId;
  }
}
